<template>
  <div class="centered" id="parade_page" v-if="loaded">
<!--
    <div id="genres" v-show="searcProps.genres_show" class="noselect">
        <a :class="searcProps.genres.indexOf(index) != -1 ? 'active' : ''" v-for="(genre,index) in $store.genres" v-text="genre" :key="index" @click="pushOrPull(searcProps.genres, index)"></a>
    </div>
-->


  
    <!-- <div class="lnk_switch">
      <a :class="(theme == 'light' ? 'active' : '')" @click="$emit('change_theme', 'light')">השבוע</a>
      <a :class="(theme == 'dark' ? 'active' : '')" @click="$emit('change_theme', 'dark')">החודש</a>
    </div> -->
    <h1 class="title colord">המואזנים ביותר בשבוע החולף</h1>
    <div id="items_list" class="big_items">

      <div class="item_wrapper" v-for="(item,index) in hero" :key="item.id">
          <CatalogItem :item="item" @play="$emit('play', item)" @open_widget="$emit('open_widget', item)" :rank="index+1" />
      </div>
      
    </div>
    
    <div class="clr"></div>
    
    <!-- <div class="left"><select></select></div> -->
    <h1 class="title">הלינקטונים המואזנים בחודש האחרון</h1>

    <div id="items_list">

      <div class="item_wrapper" v-for="item in items" :key="item.id">
          <CatalogItem :item="item" @play="$emit('play', item)" @open_widget="$emit('open_widget', item)" />
      </div>
      
    </div>
    <Loader v-if="on_loading" />

  </div>
</template>

<script>

import CatalogItem from '../components/catalog/item.vue';
import Loader from '../components/loader.vue';


export default {
  props: ["searcProps"],
  components: { CatalogItem, Loader},
  data(){
    return {
      loaded: false,
      artists: [],
      items: [],
      hero: [],
      on_loading: false,
      page: 0,
      searchTimer: null,
    }
  },
  methods: {
    onDrop(e) {
      this.dropped.push(e.data);
    },
  },
  mounted(){
    var self = this;
    
    self.$emit('show_loader')
    
    this.on_loading = true;
    this.api({ action: 'parade' }, function(data){ 

      for (let i in data.data.hero)
      {
        data.data.hero[i].pic_tumb = data.data.hero[i].pic_tumb_share;
      }

      self.items = data.data.items; 
      self.hero = data.data.hero; 
      self.on_loading = false;
      self.loaded = true;
      self.$emit('loaded');
    });


  },

  
}
</script>

<style lang="scss">
#parade_page {

  #items_list .item .texts h4 { color:#fff; padding-right: 0px; padding-top: 15px; }

  .lnk_switch {
    & { border:1px solid #1e212a; padding: 3px; background: #fff; display: inline-block; border-radius: 25px; }
    a { height: 22px; border-radius: 20px; display: inline-block; padding: 0 8px;  color: #1e212a; }
    a.active { background: #1e212a; color: #fff;}
  }
  .big_items .item_wrapper:nth-child(n+4) .item {
    .texts { padding-right: 58px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      -webkit-box-orient: vertical;

      h3 { font-weight: bold; text-overflow: ellipsis; overflow:hidden; white-space: nowrap;}
      h4 { color: #333 !important; padding:0px !important; text-overflow: ellipsis; overflow:hidden; white-space: nowrap;}
    }
    i { position: absolute; right: 10px; top: 0px; line-height: normal; font-weight: normal; opacity: 0.3; letter-spacing: -6px;}
    .date { display: none;}
    
    .play_btn { background:#fff !important; border: 2px solid #eee; height: 40px !important; width: 40px !important; line-height: 35px !important; bottom: 30px !important; left: -20px !important;
      svg {/*background-image:linear-gradient(135deg, #ff1661 13%, #00b7ff 123%) !important; */ color: #ba438d !important;}
    }
  }

  #items_list .item_wrapper { padding:  20px 15px !important;
    @media (min-width: 600px) { }
    @media (max-width: 600px) { width:100% !important; }
  }
}

</style>